import React from 'react'

const External = props => (
	<svg {...props}>
		<polygon points="16 0 13.6666667 7 9 2.33333333" />
		<path d="M4,2 C2.8954305,2 2,2.8954305 2,4 L2,12 C2,13.1045695 2.8954305,14 4,14 L12,14 C13.1045695,14 14,13.1045695 14,12 L16,6.45751953 L16,12 C16,14.209139 14.209139,16 12,16 L4,16 C1.790861,16 2.705415e-16,14.209139 0,12 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L9.72711182,0 L4,2 Z" />
		<polygon points="6 11.4142136 4.58578644 10 12 2.58578644 13.4142136 4" />
	</svg>
)

export default External
